namespace Roodik.Game
{
	import ResourceProvider = Roodik.Core.ResourceProvider;
	import IGameResources = Roodik.Core.IGameResources;
	import ITimer = Roodik.Core.ITimer;
	import Timer = Roodik.Core.Timer;
	
	export class GameModel
	{
		private _boardModel : BoardModel;
		private _difficulty:number = 0;
		private _maxLevels:number = 1;//rewrite by config
		private _timer : ITimer;
		private _maxBoardTime : number = 150;
		private _timesLeft : number = this._maxBoardTime;
		private _initialized:boolean = false;

		constructor(private _resources:IGameResources,
		            private _levelComplete:(result:number, timesLeft:number)=>void,
		            private _timeUpdated:()=>void)
		{
			this._timer = new Timer(this.timerTick.bind(this));
			this._timer.stop();
		}

		private timerTick(time : number)
		{
			if (this._initialized)
			{
				this._timesLeft = this._maxBoardTime - this._timer.seconds;

				if(this._timesLeft < 0)
				{
					this._timesLeft = 0;

					this._timer.stop();
					this._timer.destroy();

					this.gameWasFinished(BoardModel.TIMES_UP);
				}

				if (this._timeUpdated != null)
				{
					this._timeUpdated();
				}
			}
		}
		
		public initialize(callBackInitialized:(boardModel:BoardModel)=>void)
		{
			this._initialized = false;
			this.loadLevel(this._difficulty, callBackInitialized);
		}
		
		private loadLevel(difficulty:number, callBackInitialized:(boardModel:BoardModel)=>void)
		{
			let levelsUrl : ILevels = this._resources.getResourceByName("LevelsData").data;
			this._maxLevels = levelsUrl.levels.length;

			let level = Math.round(Math.random()*(levelsUrl.levels[difficulty].length-1));
			let key:string = "Level_"+difficulty+"x"+level;
			let puzzleData : IPuzzleData = this._resources.getResourceByName(key) != null ? this._resources.getResourceByName(key).data : null;
			let name:string = "icons";

			this._resources.loadDbLazy("icons", "resources/images/",
			() => {},
			()=>{
				if (puzzleData == null)
				{
					let provider = new ResourceProvider();
					console.log("url = ",levelsUrl.levels[difficulty][level].url);
					provider.add(key, levelsUrl.levels[difficulty][level].url);
					this._resources.loadLazy(provider,()=>{},()=>
					{
						this.createLevel(this._resources.getResourceByName(key).data, callBackInitialized);
					});
				}
				else
				{
					this.createLevel(puzzleData, callBackInitialized);
				}
			});
		}
		
		private createLevel(puzzleData : IPuzzleData, callBackInitialized:(boardModel:BoardModel)=>void)
		{
			this._boardModel = new BoardModel(puzzleData.board, this.gameWasFinished.bind(this));
			
			callBackInitialized(this._boardModel);
			this._initialized = true;
		}
		
		private gameWasFinished(result : number)
		{
			if (result == BoardModel.HAS_NO_TILES)
			{
				this._difficulty++;
			}

			if (this._difficulty < this._maxLevels)
			{
				this._levelComplete(result, this._timesLeft);
			}
			else
			{
				this._levelComplete(BoardModel.GAME_COMPLETE, this._timesLeft);
			}
		}

		private _timeReady:boolean = false;
		public timeReady()
		{
			this._timeReady = true;
			this.unPause();
		}

		public reshuffle()
		{
			this._boardModel.reshuffle(true);
		}
		
		public pause()
		{
			if (this._timeReady)
			{
				this._timer.stop();
			}
		}
		
		public unPause()
		{
			if (this._timeReady)
			{
				this._timer.start();
			}
		}

		public get timesLeft() : number { return this._timesLeft; }
		public get maxLevels() : number { return this._maxLevels; }

		public destroy()
		{
			this._timer.stop();
			this._timer.destroy();
			this._timer = null;

			this._timeUpdated = null;
			this._boardModel.destroy();
			
			this._boardModel = null;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Model/GameModel.ts